import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

function Login() {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginRedirect(loginRequest);
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-icon">SA</div>
                <h1>Store Audit</h1>
                <p>
                    AI-powered compliance monitoring for United Petroleum.
                    Sign in with your organisation account to continue.
                </p>
                <button className="login-btn" onClick={handleLogin}>
                    Sign in with Microsoft
                </button>
            </div>
        </div>
    );
}

export default Login;
